import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { CatalogService } from '@catalog/catalog.service';
import { EncryptionProviderService } from '@root/shared/encryption.service';
import { ErrorHandler } from './../../utils/error-handler.service';
import { Features } from '@common/common.constant';
import { AuthService } from '@root/shared/auth.service';
import { CatalogueTab , CATALOGUE_TABS} from '@catalog/catalogue.constant';
@Component({
  selector: 'app-catalogue',
  templateUrl: './catalogue.component.html',
  styleUrls: ['./catalogue.component.scss'],
  providers: [CatalogService],
})
export class CatalogueComponent implements OnInit {

  pdfTypes: any;

  categoryList: any;

  imageSectionList: any;

  features = Features;

  public userInfo: any;

  public primaryTabs: CatalogueTab[] = CATALOGUE_TABS;

  public primaryTabMap: {[key:string]:CatalogueTab} ={}

  public selectedPrimaryTab:string;

  public selectedSecondaryTab:string;

  public selectedPrimaryTabIndex = 0;

  public selectedSecondaryTabIndex = 0;

  public articleData:any;
  
  constructor(
   private catalogService: CatalogService,
  private encryptionProviderService:EncryptionProviderService,
  private errorHandler: ErrorHandler) {
   }

  ngOnInit() {
    this.userInfo = AuthService.userInfo();
    this.setPrimaryTabs();
  }

  private setPrimaryTabs(){
    const primaryTabs: CatalogueTab[] = JSON.parse(JSON.stringify(CATALOGUE_TABS));
    let defaultPrimaryTab: CatalogueTab;
    for(let pTab of primaryTabs){
      this.primaryTabMap[pTab.name] = pTab;
      if(!AuthService.isAccess(pTab.name)){
        pTab.disabled = true;
      }else if(!defaultPrimaryTab){
        defaultPrimaryTab = pTab;
      }
    }

    if(defaultPrimaryTab){
      this.selectedPrimaryTab = defaultPrimaryTab.name
      this.selectedSecondaryTab = defaultPrimaryTab.defaultSecondaryTab;
    }

    this.setTabDependentData();
  }

  private setTabDependentData(){
    if(this.selectedPrimaryTab === 'Products' || this.selectedPrimaryTab === 'Investors' || this.selectedPrimaryTab === 'Partners' || this.selectedPrimaryTab === 'Downloads'){
      this.readPDFTypes();
    }
    if(this.selectedPrimaryTab === 'Products' || this.selectedPrimaryTab === 'NFO' || this.selectedPrimaryTab === 'Contact Us' || this.selectedPrimaryTab === 'Relationship Manager' || this.selectedPrimaryTab === "CEO Desk"
    || this.selectedPrimaryTab === 'Latest News' || this.selectedPrimaryTab === 'Media' || this.selectedPrimaryTab === 'Advertisement'){
      this.getCategories();
    }
    if(this.selectedPrimaryTab === 'Products' || this.selectedPrimaryTab === 'NFO' || this.selectedPrimaryTab === "CEO Desk" || this.selectedPrimaryTab === 'Careers'){
      this.getImageCategories();
    }

    if(this.selectedPrimaryTab === 'Expense Ratio'){
      this.pdfTypes=[{id: 4, type: "Disclosure"}]
    }
  }

  onPrimaryTabChange(change: MatTabChangeEvent) {
    if (change.tab) {
      this.selectedPrimaryTab = change.tab.textLabel;
      this.selectedPrimaryTabIndex = change.index;
      this.selectedSecondaryTab =  this.primaryTabMap[this.selectedPrimaryTab] ?  this.primaryTabMap[this.selectedPrimaryTab].defaultSecondaryTab : null;
      this.selectedSecondaryTabIndex =0;
    }
    this.setTabDependentData();
  }

  onSecondaryTabChange(change: MatTabChangeEvent) {
    if (change.tab) {
      this.selectedSecondaryTab = change.tab.textLabel;
      this.selectedSecondaryTabIndex = change.index;
    }
  }

  public readPDFTypes() {
    const data = {
      category: this.selectedPrimaryTab.toLowerCase(),
    };
    this.catalogService.readPDFTypes(data).subscribe(
      (response) => {
        if(response.status === 0){
        this.pdfTypes = response.data.types;
        }else{
          this.errorHandler.handleError(response);
        }
      },
      (error) => {
        this.errorHandler.handleError(error);
       }
    );
  }

  public getCategories() {
    const data ={
      categorySection: this.selectedPrimaryTab.toLowerCase()
    }
    if(data.categorySection === "ceo desk"){
      data.categorySection = "ceo's desk"
    }
    this.catalogService.getExcelCategories(data).subscribe(
      (response) => {
        if(response.status === 0){
        this.categoryList = response.data.categories;
        }else{
          this.errorHandler.handleError(response);
        }
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }

  public getImageCategories() {
    const data ={
      categorySection: this.selectedPrimaryTab.toLowerCase()
    }
    if(data.categorySection === "ceo desk"){
      data.categorySection = "ceo's desk"
    }
    this.catalogService.readAllImageCategories(data).subscribe(
      (response) => {
        if(response.status === 0){
        this.imageSectionList = response.data.categories;
        }else{
          this.errorHandler.handleError(response);
        }
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }

  generateGuid(url: string) {
    let result = '';
    const length = 32;
    const chars =
      '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for (let i = length; i > 0; --i) {
      result += chars[Math.round(Math.random() * (chars.length - 1))];
    }

    this.encryptionProviderService.setGuid({
      key: url,
      value: result,
    });

    return result;
  }  

  onUploadThumbnail(data: any){
    this.selectedSecondaryTab = 'Thumbnail Images';
    this.selectedSecondaryTabIndex = 2;
    this.articleData = data;
  }
}
